/**
 * @packageDocumentation
 * @module api.functional.admin.invitations.pending
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponseArrayInvitationWithCompany } from "../../../../structures/ServiceResponseArrayInvitationWithCompany";

/**
 * @controller InvitationController.getPendingInvitations
 * @path GET /admin/invitations/pending
 * @accessor api.functional.admin.invitations.pending.getPendingInvitations
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getPendingInvitations(
  connection: IConnection,
): Promise<getPendingInvitations.Output> {
  return PlainFetcher.fetch(connection, {
    ...getPendingInvitations.METADATA,
    template: getPendingInvitations.METADATA.path,
    path: getPendingInvitations.path(),
  });
}
export namespace getPendingInvitations {
  export type Output = ServiceResponseArrayInvitationWithCompany;

  export const METADATA = {
    method: "GET",
    path: "/admin/invitations/pending",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/admin/invitations/pending";
}
